import secureApi from "../services/secureApi";

export const importProductsApi = async (file, onUploadProgress) => {
  const formData = new FormData();

  formData.append("file", file);

  const response = await secureApi.post(
    "/admin-upload/products/import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    }
  );

  return response.data;
};
